import { PaymentMethodType } from '../enums/Tokens';
import { Validation } from '../types';
import { Nullable } from '../utilities';

export class BasePaymentMethod {
  static canVault = false;

  readonly type: PaymentMethodType;

  public displayName: string;

  public container: Nullable<Element>;

  constructor(type: PaymentMethodType, name: string) {
    this.type = type;
    this.displayName = name;
  }

  get canVault(): boolean {
    return (this.constructor as typeof BasePaymentMethod).canVault === true;
  }

  setupAndValidate(): Promise<boolean> {
    return Promise.resolve(true);
  }

  mount(): Promise<boolean> {
    return Promise.resolve(true);
  }

  tokenize(): Promise<void> {
    return Promise.resolve();
  }

  validate(): Promise<Validation> {
    return Promise.resolve({ valid: true, validationErrors: [] });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setDisabled(disabled: boolean): Promise<void> {
    return Promise.resolve();
  }
}
